import React from 'react';
import DealerAd from '../DealerAd/DealerAd';
import DealerAdV2 from '../DealerAd/DealerAdV2';
import queryString from 'query-string';

const App: React.FC = () => {
  const options: any = queryString.parse(location.search);

  if (!options) {
    return null;
  }

  if (options.newApi) {
    return (
      <DealerAdV2
        translationVersion={window.__DEALER_T_VERSION__}
        realEstateId={options.realEstateId || ''}
        userGuid={options.userGuid || ''}
        biClientId={options.biClientId || ''}
        biClientIdSigned={options.biClientIdSigned || ''}
        withCloseButton={options.withCloseButton || false}
      />
    );
  }

  return (
    <DealerAd
      translationVersion={window.__DEALER_T_VERSION__}
      realEstateId={options.realEstateId || ''}
      userGuid={options.userGuid || ''}
      biClientId={options.biClientId || ''}
      withCloseButton={options.withCloseButton || false}
    />
  );
};

export default App;
